import React from 'react';
import { FormattedDTE } from '@upstart/harmony/lib/legos/dtEntitiesTypes';
import DTETypeahead from 'components/DTETypeahead/DTETypeahead';
import { getUarAddOnEntities } from 'util/dmsUtils';
import { AddOn } from './AddOnsModal';

interface Props {
  dtEntities: FormattedDTE[];
  dteMap: Map<string, FormattedDTE>;
  addOn: AddOn;
  index: number;
  onChange: (index: number, selected: FormattedDTE) => void;
  disabled: boolean;
}

export const AddOnsDteTypeahead = (props: Props) => {
  const { dtEntities, dteMap, addOn, index, onChange, disabled } = props;

  return (
    <DTETypeahead
      dtEntities={getUarAddOnEntities(dtEntities)}
      selectedDTE={dteMap.get(addOn?.dtEntityId || '')}
      onChange={([selected]) => {
        onChange(index, selected);
      }}
      recenterClearButton
      disabled={disabled}
    />
  );
};
